import { transformacion } from 'lib.common';
import { apiRestUrl } from 'src/config/keys';
import { format } from 'date-fns';
import { TipoCambioSUNAT } from '../../bussines/entities/tipoCambioSUNAT.entity';
import { paramsGetListaTipoCambioSUNAT } from '../../bussines/params/ListaTipoCambioSUNAT.params';
export class ListaTipoCambioSUNATExpressProvider {
   private apiKey: string;
   constructor(apiKey: string) {
      this.apiKey = apiKey;
   }
   async getListaTipoCambioSUNAT(params: paramsGetListaTipoCambioSUNAT): Promise<TipoCambioSUNAT[]> {
      try {
         let url = transformacion.appendUrl(apiRestUrl, `/tipoCambio`);
         url.searchParams.append('moneda', params.moneda);
         url.searchParams.append('anio', String(params.anio));
         url.searchParams.append('mes',params.mes);
         const response = await fetch(url, {
            headers: {
               'Content-Type': 'application/json',
               dsapikey: this.apiKey
            }
         });
         if (response.ok) {
            const data = await response.json();
            if (data) {
               return data;
            }
            throw new Error(`No se encontraron datos`);
         }
         const errorText = await response.text();
         throw new Error(`Error ${response.status}: ${response.statusText} - ${errorText}`);
      } catch (error) {
         throw error;
      }
   }
}
